import React, { useCallback } from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { I18n } from '@fiverr-private/i18n-react';
import { LinkCard, Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { useReviewsContext } from '../../../shared/context';
import { getImagePreview, getCategoryKey } from '../../../../utils/gigUtils';
import { reportClickEvent } from '../../../../utils/reports/freelancerReviews/gigInfo';
import LazyImage from '../../../shared/LazyImage';
import useMedia from '../../../shared/hooks/useMedia';
import { GigInfoPropType } from './GigInfoPropType';

import './GigInfo.styles.scss';

/**
 * @param {number} amountInUsd
 * @param {CurrencyConverter} currency
 * @returns {string}
 */
export const GigInfo = ({ gig }) => {
    const { withLinkToGig } = useReviewsContext();
    const isSmallScreen = useMedia();
    const assetImageUrl = getImagePreview(gig.assets, gig.attachments);
    const categoryNameKey = getCategoryKey({
        categoryId: gig.category_id,
        subCategoryId: gig.sub_category_id,
        nestedSubCategoryId: gig.nested_sub_category_id,
    });
    const { organizationId } = getContext();

    const handleClick = useCallback(() => {
        reportClickEvent({
            orgId: organizationId,
            gigId: gig.gig_id,
        });
    }, [gig, organizationId]);

    return (
        <>
            {isSmallScreen ? (
                <Text size="b_xs" color="bodySecondary" marginTop="3">
                    <I18n k="reviews.gigs.ordered" />
                </Text>
            ) : null}
            <LinkCard
                as={withLinkToGig ? 'a' : 'div'}
                href={withLinkToGig ? gig.gig_url : null}
                onClick={handleClick}
                padding={isSmallScreen ? '4' : '2'}
                borderWidth="sm"
                borderColor="grey_300"
                display="inlineFlex"
            >
                <Stack direction="row" alignItems="center">
                    {isSmallScreen ? null : <LazyImage alt="gig" src={assetImageUrl} maxWidth="56px" height="33px" />}
                    <Text size="b_xs" color="bodySecondary">
                        <I18n k={categoryNameKey} />
                    </Text>
                </Stack>
            </LinkCard>
        </>
    );
};

GigInfo.propTypes = {
    gig: GigInfoPropType.isRequired,
};
